module.exports = __webpack_public_path__ + "static/dafiti-logo-e5f241393eb81cc728fcb050c8567198.png";